import { render, staticRenderFns } from "./AppConfirmDialogComponent.vue?vue&type=template&id=52638077&scoped=true"
import script from "./AppConfirmDialogComponent.vue?vue&type=script&lang=js"
export * from "./AppConfirmDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./AppConfirmDialogComponent.vue?vue&type=style&index=0&id=52638077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52638077",
  null
  
)

export default component.exports